module.exports = __webpack_public_path__ + "img/7.9b7df0db.png";